// Auto-generated by run_coral_reef_watch_daily.py
export const crwDailyDates = {
  "dhw": "2026-08-22",
  "hotspot": "2026-08-22",
  "coraltemp": "2026-08-28",
  "sst_anomaly": "2026-08-28",
  "sst_trend_7d": "2026-08-28",
  "baa": "2026-08-22"
};

// Available map frames by portal scope and display resolution.
export const crwDailyDateCatalog = {
  "palau": {
    "0.25deg": {
      "baa": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "coraltemp": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "dhw": [
        "2026-08-08",
        "2026-08-09",
        "2026-08-10",
        "2026-08-11",
        "2026-08-12",
        "2026-08-13",
        "2026-08-14",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "hotspot": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "sst_anomaly": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "sst_trend_7d": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ]
    },
    "native": {
      "baa": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "coraltemp": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "dhw": [
        "2026-08-08",
        "2026-08-09",
        "2026-08-10",
        "2026-08-11",
        "2026-08-12",
        "2026-08-13",
        "2026-08-14",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "hotspot": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "sst_anomaly": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "sst_trend_7d": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ]
    }
  },
  "rmi": {
    "0.25deg": {
      "baa": [
        "2026-08-08"
      ],
      "coraltemp": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "dhw": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "hotspot": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "sst_anomaly": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    },
    "native": {
      "baa": [
        "2026-08-08"
      ],
      "coraltemp": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "dhw": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "hotspot": [
        "2026-08-08",
        "2026-08-20",
        "2026-08-21",
        "2026-08-22"
      ],
      "sst_anomaly": [
        "2026-08-09",
        "2026-08-26",
        "2026-08-27",
        "2026-08-28"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    }
  },
  "pacific": {
    "0.25deg": {
      "coraltemp": [
        "2026-08-09"
      ],
      "dhw": [
        "2026-08-08"
      ],
      "hotspot": [
        "2026-08-08"
      ],
      "sst_anomaly": [
        "2026-08-09"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    },
    "0.5deg": {
      "coraltemp": [
        "2026-08-09"
      ],
      "dhw": [
        "2026-08-08"
      ],
      "hotspot": [
        "2026-08-08"
      ],
      "sst_anomaly": [
        "2026-08-09"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    },
    "1deg": {
      "coraltemp": [
        "2026-08-09"
      ],
      "dhw": [
        "2026-08-08"
      ],
      "hotspot": [
        "2026-08-08"
      ],
      "sst_anomaly": [
        "2026-08-09"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    },
    "2deg": {
      "coraltemp": [
        "2026-08-09"
      ],
      "dhw": [
        "2026-08-08"
      ],
      "hotspot": [
        "2026-08-08"
      ],
      "sst_anomaly": [
        "2026-08-09"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    },
    "native": {
      "coraltemp": [
        "2026-08-09"
      ],
      "dhw": [
        "2026-08-08"
      ],
      "hotspot": [
        "2026-08-08"
      ],
      "sst_anomaly": [
        "2026-08-09"
      ],
      "sst_trend_7d": [
        "2026-08-09"
      ]
    }
  }
};

// Dated Marshall Islands bleaching-alert gauge maps.
export const crwRmiAlertDates = {
  "CRW_BAA_Current_Rounded": [
    "2026-08-08",
    "2026-08-09"
  ],
  "CRW_BAA_Week_01-04": [
    "2026-08-02"
  ],
  "CRW_BAA_Week_05-08": [
    "2026-08-02"
  ],
  "CRW_BAA_Week_09-12": [
    "2026-08-02"
  ]
};
